import { BaseModel } from '../base.model'
import { Question } from '../question.model'
  
export class Section extends BaseModel<Section> {
  id: number
  name: string
  state: string
  comment: string
  folderId: number
  questions: Question[]
  base: number //id of base section to copy

  constructor(attributes: Object = {}, base: number = null) {
    super(attributes)
    if (base) {
      this.base = base
    }
  }

  removed(): boolean {
    return this.state == 'removed'
  }

  disabled(): boolean {
    return this.state == 'disabled'
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/exams/section.model.ts